import React from 'react';
import styled from 'styled-components';
import { IntroProps } from './utils';
import { SPACERS } from '../../../design-system/settings/variables/Spacers';
import TrueImpactAnimation from '../../../design-system/base/TrueImpactAnimation';
import TrueImpactText from '../../../design-system/base/TrueImpactText';
import TrueImpactBulletPoint from '../../../design-system/components/TrueImpactBulletPoint';
import TrueImpactButton from '../../../design-system/components/TrueImpactButton';
import inspireImageSrc from 'shared/statics/welcome-inspire.png';

type IntroInspireProps = IntroProps

const StyledDiv = styled.div`
  text-align: center;
  margin-top: ${SPACERS.large};
  padding-bottom: ${SPACERS.large};
  .welcome-icon {
    width: 382px;
    height: 382px;
    margin-bottom: -45px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 382px;
    img {
      max-width: 548px;
    }
    background: radial-gradient(
      50% 50% at 50% 50%,
      #d9eaf1 0%,
      rgba(217, 234, 241, 0) 100%
    );
  }
  .welcome-inspire-heading {
  }
  .welcome-inspire-subheading {
    max-width: 355px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: ${SPACERS.large};
  }
  .inspire-bullet-point-wrapper {
    display: inline-block;
    margin-bottom: ${SPACERS.extraLarge};
  }
`;

const IntroInspire: React.FC<IntroInspireProps> = ({ handleNextStep }) => {
  return (
    <TrueImpactAnimation variant="appear">
      <StyledDiv>
        <div className="welcome-icon">
          <img
            src={inspireImageSrc}
            title="welcome-inspire"
            alt="welcome-inspire"
            className="welcome-inspire"
          />
        </div>
        <TrueImpactText
          variant="heading-page"
          className="welcome-inspire-heading"
        >
          Inspire support
        </TrueImpactText>
        <TrueImpactText
          variant="body-large"
          className="welcome-inspire-subheading"
        >
          Quantify the outcomes each donor can claim on the issues they most
          care about
        </TrueImpactText>
        <div className="inspire-bullet-point-wrapper">
          <div>
            <TrueImpactBulletPoint text="You select impact metrics from our library." />
            <TrueImpactBulletPoint text="We’ll calculate your donors’ claim." />
            <TrueImpactBulletPoint text="You bask in their appreciation!" />
          </div>
        </div>
        <TrueImpactAnimation variant="pulse" animationDelay={10}>
          <TrueImpactButton onClick={handleNextStep}>Continue</TrueImpactButton>
        </TrueImpactAnimation>
      </StyledDiv>
    </TrueImpactAnimation>
  );
};

export default IntroInspire;
